// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".alert-danger[data-v-75ba45b9]{color:#db4065;background-color:#7e0b27;border-color:#fbbfcd}.btn-close[data-v-75ba45b9]{color:#fff!important}", ""]);
// Exports
module.exports = exports;
